import { render, staticRenderFns } from "./FeatureDialog.vue?vue&type=template&id=034574f4"
import script from "./FeatureDialog.vue?vue&type=script&lang=js"
export * from "./FeatureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports